var map = {
	"./AashiqueAhmedIqbal.png": 598,
	"./BusinessintheTimeofContagion.jpeg": 599,
	"./KarunaWielenga.png": 600,
	"./LakshmiSubramanian.png": 601,
	"./LouizaRodrigues.png": 602,
	"./MadMenofBombay.png": 603,
	"./MilanBalaban.png": 604,
	"./PowerPrivilegePosture.jpeg": 605,
	"./SaritaSundar.png": 606,
	"./Speaker1.png": 607,
	"./SusiePak.png": 608,
	"./TheGlobalBlueJeansTransformation.jpg": 609,
	"./TimberTradeTrajectory.jpeg": 610,
	"./TraceyPanek.png": 611,
	"./TypewriterTipTip.png": 612,
	"./WilliamMazzarella.png": 613,
	"./details-banner/BusinessInTheTimeOfContagion.png": 614,
	"./details-banner/MadMenOfBombay.png": 615,
	"./details-banner/PowerPrivilegeposture.png": 616,
	"./details-banner/TheGlobalBlueJeans.png": 617,
	"./details-banner/TimberTradeTrajectory.png": 618,
	"./details-banner/TypewriterTipTip.png": 619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 597;